import React, { useState } from "react";
import DateTimePicker from "components/GenericComponent/DateTimePicker";
import { startOfMonth, isAfter, isBefore, startOfDay } from "date-fns";
import { pushNotification } from "utils/notifications";

/** Khoảng mặc định: từ đầu tháng hiện tại đến hôm nay */
export const khoangMacDinh = () => ({
  dtFrom: "",
  dtTo: new Date(),
});

/** Bỏ trống Từ ngày = lấy từ đầu (01/01/1900) */
export const NGAY_BAT_DAU_MAC_DINH = new Date(1900, 0, 1);
/** Bỏ trống Đến ngày = lấy tới cuối (01/01/2100) */
export const NGAY_KET_THUC_MAC_DINH = new Date(2100, 0, 1);

export const SearchBarTrangChu = ({ onApply, loading }) => {
  const homNay = new Date();
  const [filters, setFilters] = useState(khoangMacDinh);

  const handleDateChange = (field) => (date) => {
    // Không chặn cứng bằng maxDate nữa: cho chọn rồi báo lỗi, tránh bấm mà không có phản hồi
    if (date && isAfter(startOfDay(date), startOfDay(homNay))) {
      pushNotification(
        field === "dtFrom"
          ? "Từ ngày không được lớn hơn ngày hiện tại!"
          : "Đến ngày không được lớn hơn ngày hiện tại!",
        "error",
      );
      return;
    }

    setFilters((prev) => {
      const next = { ...prev, [field]: date };

      // Giữ 2 mốc luôn hợp lệ với nhau khi người dùng đổi 1 bên
      if (next.dtFrom && next.dtTo && isAfter(next.dtFrom, next.dtTo)) {
        if (field === "dtFrom") next.dtTo = date;
        else next.dtFrom = date;
      }
      return next;
    });
  };

  const handleSubmit = (e) => {
    if (e) e.preventDefault();

    const gioiHan = startOfDay(homNay);

    // Chỉ soi ngày người dùng thực sự chọn, mốc mặc định (1900/2100) không tính là "quá ngày hiện tại"
    if (filters.dtFrom && isAfter(startOfDay(filters.dtFrom), gioiHan)) {
      pushNotification("Từ ngày không được lớn hơn ngày hiện tại!", "error");
      return;
    }
    if (filters.dtTo && isAfter(startOfDay(filters.dtTo), gioiHan)) {
      pushNotification("Đến ngày không được lớn hơn ngày hiện tại!", "error");
      return;
    }

    // Để trống Từ ngày thì lấy từ 01/01/1900, để trống Đến ngày thì lấy tới 01/01/2100
    const dtFrom = filters.dtFrom || NGAY_BAT_DAU_MAC_DINH;
    const dtTo = filters.dtTo || NGAY_KET_THUC_MAC_DINH;

    if (isAfter(startOfDay(dtFrom), startOfDay(dtTo))) {
      pushNotification("Từ ngày không được lớn hơn Đến ngày!", "error");
      return;
    }
    if (isBefore(startOfDay(dtTo), startOfDay(dtFrom))) {
      pushNotification("Đến ngày không được nhỏ hơn Từ ngày!", "error");
      return;
    }

    onApply({ dtFrom, dtTo });
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="search-new d-flex flex-row align-items-end justify-content-start gap-3 flex-wrap">
        <div className="input-sm-new" style={{ flex: 1, minWidth: "140px" }}>
          <label className="font-color-default font-bold">Từ ngày</label>
          <DateTimePicker
            value={filters.dtFrom}
            onChange={handleDateChange("dtFrom")}
            placeholder="Chọn ngày"
          />
        </div>

        <div className="input-sm-new" style={{ flex: 1, minWidth: "140px" }}>
          <label className="font-color-default font-bold">Đến ngày</label>
          <DateTimePicker
            value={filters.dtTo}
            onChange={handleDateChange("dtTo")}
            placeholder="Chọn ngày"
            minDate={filters.dtFrom}
          />
        </div>

        <div className="input-sm-new mt-1">
          <button
            type="submit"
            className="btn btn-info-new"
            style={{ paddingTop: "7px" }}
            disabled={loading}
          >
            <i className="la la-search"></i> Tìm kiếm
          </button>
        </div>
      </div>
    </form>
  );
};
